export const menuItems = [
	{ key: "0", text: "Profile", link: "/profile/settings" },
	{ key: "1", text: "Notifications", link: "/profile/inbox" },
	{ key: "2", text: "History", link: "/profile/history" },
	{ key: "3", text: "Documents", link: "/profile/documents" },
	{ key: "4", text: "My Bonuses", link: "/profile/bonuses" },
	{ key: "5", text: "Deposit", link: "/profile/deposit" },
	{ key: "6", text: "Withdraw", link: "/profile/withdraw" },
];

export const dropdownItems = [
	{ key: "game", value: "GAME" },
	{ key: "deposit", value: "PAYMENT" },
	{ key: "pending_withdraw", value: "PENDING_PAYMENT" },
];
